export const US_REGIONS = [
  "Northeast",
  "Midwest",
  "Southwest",
  "West",
  "Southeast",
  "Other"
];

export const US_STATES_AND_TERRITORIES = [
  { Maine: "ME" },
  { Delaware: "DE" },
  { "New Hampshire": "NH" },
  { Vermont: "VT" },
  { Massachusetts: "MA" },
  { "Rhode Island": "RI" },
  { Maryland: "MD" },
  { Connecticut: "CT" },
  { "New York": "NY" },
  { "New Jersey": "NJ" },
  { Pennsylvania: "PA" },
  { Ohio: "OH" },
  { Indiana: "IN" },
  { Michigan: "MI" },
  { Illinois: "IL" },
  { Missouri: "MO" },
  { Wisconsin: "WI" },
  { Minnesota: "MN" },
  { Iowa: "IA" },
  { Kansas: "KS" },
  { Nebraska: "NE" },
  { "South Dakota": "SD" },
  { "North Dakota": "ND" },
  { Texas: "TX" },
  { Oklahoma: "OK" },
  { "New Mexico": "NM" },
  { Arizona: "AZ" },
  { Colorado: "CO" },
  { Wyoming: "WY" },
  { Montana: "MT" },
  { Idaho: "ID" },
  { Washington: "WA" },
  { Oregon: "OR" },
  { Utah: "UT" },
  { Nevada: "NV" },
  { California: "CA" },
  { Alaska: "AK" },
  { Hawaii: "HI" },
  { "West Virginia": "WV" },
  { Virginia: "VA" },
  { Kentucky: "KY" },
  { Tennessee: "TN" },
  { "North Carolina": "NC" },
  { "South Carolina": "SC" },
  { Georgia: "GA" },
  { Alabama: "AL" },
  { Mississippi: "MS" },
  { Arkansas: "AR" },
  { Louisiana: "LA" },
  { Florida: "FL" },
  { "District of Columbia": "DC" },
  { "American Samoa": "AS" },
  { Guam: "GU" },
  { "Northern Mariana Islands": "MP" },
  { "Puerto Rico": "PR" },
  { "U.S. Virgin Islands": "VI" }
];

export const MAPPING_OF_US_REGIONS_TO_US_STATES_AND_TERRITORIES_AND_THEIR_ABBREVIATIONS = {
  Northeast: [
    { Maine: "ME" },
    { Delaware: "DE" },
    { "New Hampshire": "NH" },
    { Vermont: "VT" },
    { Massachusetts: "MA" },
    { "Rhode Island": "RI" },
    { Maryland: "MD" },
    { Connecticut: "CT" },
    { "New York": "NY" },
    { "New Jersey": "NJ" },
    { Pennsylvania: "PA" }
  ],
  Midwest: [
    { Ohio: "OH" },
    { Indiana: "IN" },
    { Michigan: "MI" },
    { Illinois: "IL" },
    { Missouri: "MO" },
    { Wisconsin: "WI" },
    { Minnesota: "MN" },
    { Iowa: "IA" },
    { Kansas: "KS" },
    { Nebraska: "NE" },
    { "South Dakota": "SD" },
    { "North Dakota": "ND" }
  ],
  Southwest: [
    { Texas: "TX" },
    { Oklahoma: "OK" },
    { "New Mexico": "NM" },
    { Arizona: "AZ" }
  ],
  West: [
    { Colorado: "CO" },
    { Wyoming: "WY" },
    { Montana: "MT" },
    { Idaho: "ID" },
    { Washington: "WA" },
    { Oregon: "OR" },
    { Utah: "UT" },
    { Nevada: "NV" },
    { California: "CA" },
    { Alaska: "AK" },
    { Hawaii: "HI" }
  ],
  Southeast: [
    { "West Virginia": "WV" },
    { Virginia: "VA" },
    { Kentucky: "KY" },
    { Tennessee: "TN" },
    { "North Carolina": "NC" },
    { "South Carolina": "SC" },
    { Georgia: "GA" },
    { Alabama: "AL" },
    { Mississippi: "MS" },
    { Arkansas: "AR" },
    { Louisiana: "LA" },
    { Florida: "FL" }
  ],
  Other: [
    { "District of Columbia": "DC" },
    { "American Samoa": "AS" },
    { Guam: "GU" },
    { "Northern Mariana Islands": "MP" },
    { "Puerto Rico": "PR" },
    { "U.S. Virgin Islands": "VI" }
  ]
};

export const COUNTRIES = [
  { Afghanistan: "AFG" },
  { "Aland Islands": "ALA" },
  { Albania: "ALB" },
  { Algeria: "DZA" },
  { "American Samoa": "ASM" },
  { Andorra: "AND" },
  { Angola: "AGO" },
  { Anguilla: "AIA" },
  { Antarctica: "ATA" },
  { "Antigua and Barbuda": "ATG" },
  { Argentina: "ARG" },
  { Armenia: "ARM" },
  { Aruba: "ABW" },
  { Australia: "AUS" },
  { Austria: "AUT" },
  { Azerbaijan: "AZE" },
  { Bahamas: "BHS" },
  { Bahrain: "BHR" },
  { Bangladesh: "BGD" },
  { Barbados: "BRB" },
  { Belarus: "BLR" },
  { Belgium: "BEL" },
  { Belize: "BLZ" },
  { Benin: "BEN" },
  { Bermuda: "BMU" },
  { Bhutan: "BTN" },
  { Bolivia: "BOL" },
  { "Bosnia-Herzegovina": "BIH" },
  { Botswana: "BWA" },
  { "Bouvet Island": "BVT" },
  { Brazil: "BRA" },
  { "British Indian Ocean Territory": "IOT" },
  { Brunei: "BRN" },
  { Bulgaria: "BGR" },
  { "Burkina Faso": "BFA" },
  { Burundi: "BDI" },
  { Cambodia: "KHM" },
  { Cameroon: "CMR" },
  { Canada: "CAN" },
  { "Cape Verde": "CPV" },
  { "Cayman Islands": "CYM" },
  { "Central African Republic": "CAF" },
  { Chad: "TCD" },
  { Chile: "CHL" },
  { China: "CHN" },
  { "Christmas Island": "CXR" },
  { "Cocos (Keeling) Islands": "CCK" },
  { Colombia: "COL" },
  { Comoros: "COM" },
  { "Congo, Democratic Republic of the": "COD" },
  { "Congo, Republic of": "COG" },
  { "Cook Islands": "COK" },
  { "Costa Rica": "CRI" },
  { Croatia: "HRV" },
  { Cuba: "CUB" },
  { Cyprus: "CYP" },
  { "Czech Republic": "CZE" },
  { Denmark: "DNK" },
  { Djibouti: "DJI" },
  { Dominica: "DMA" },
  { "Dominican Republic": "DOM" },
  { Ecuador: "ECU" },
  { Egypt: "EGY" },
  { "El Salvador": "SLV" },
  { "Equatorial Guinea": "GNQ" },
  { Eritrea: "ERI" },
  { Estonia: "EST" },
  { Ethiopia: "ETH" },
  { "Falkland Islands": "FLK" },
  { "Faroe Islands": "FRO" },
  { Fiji: "FJI" },
  { Finland: "FIN" },
  { France: "FRA" },
  { "French Guiana": "GUF" },
  { "French Polynesia": "PYF" },
  { "French Southern Territories": "ATF" },
  { Gabon: "GAB" },
  { Gambia: "GMB" },
  { Georgia: "GEO" },
  { Germany: "DEU" },
  { Ghana: "GHA" },
  { Gibraltar: "GIB" },
  { Greece: "GRC" },
  { Greenland: "GRL" },
  { Grenada: "GRD" },
  { Guadeloupe: "GLP" },
  { Guam: "GUM" },
  { Guatemala: "GTM" },
  { Guernsey: "GGY" },
  { Guinea: "GIN" },
  { "Guinea Bissau": "GNB" },
  { Guyana: "GUY" },
  { Haiti: "HTI" },
  { "Heard Island and McDonald Islands": "HMD" },
  { "Holy See": "VAT" },
  { Honduras: "HND" },
  { "Hong Kong": "HKG" },
  { Hungary: "HUN" },
  { Iceland: "ISL" },
  { India: "IND" },
  { Indonesia: "IDN" },
  { Iran: "IRN" },
  { Iraq: "IRQ" },
  { Ireland: "IRL" },
  { "Isle of Man": "IMN" },
  { Israel: "ISR" },
  { Italy: "ITA" },
  { "Ivory Coast": "CIV" },
  { Jamaica: "JAM" },
  { Japan: "JPN" },
  { Jersey: "JEY" },
  { Jordan: "JOR" },
  { Kazakhstan: "KAZ" },
  { Kenya: "KEN" },
  { Kiribati: "KIR" },
  { Kuwait: "KWT" },
  { Kyrgyzstan: "KGZ" },
  { Laos: "LAO" },
  { Latvia: "LVA" },
  { Lebanon: "LBN" },
  { Lesotho: "LSO" },
  { Liberia: "LBR" },
  { Libya: "LBY" },
  { Liechtenstein: "LIE" },
  { Lithuania: "LTU" },
  { Luxembourg: "LUX" },
  { Macao: "MAC" },
  { Macedonia: "MKD" },
  { Madagascar: "MDG" },
  { Malawi: "MWI" },
  { Malaysia: "MYS" },
  { Maldives: "MDV" },
  { Mali: "MLI" },
  { Malta: "MLT" },
  { "Marshall Islands": "MHL" },
  { Martinique: "MTQ" },
  { Mauritania: "MRT" },
  { Mauritius: "MUS" },
  { Mayotte: "MYT" },
  { Mexico: "MEX" },
  { Micronesia: "FSM" },
  { Moldova: "MDA" },
  { Monaco: "MCO" },
  { Mongolia: "MNG" },
  { Montserrat: "MSR" },
  { Morocco: "MAR" },
  { Mozambique: "MOZ" },
  { Myanmar: "MMR" },
  { Namibia: "NAM" },
  { Nauru: "NRU" },
  { Nepal: "NPL" },
  { Netherlands: "NLD" },
  { "Netherlands Antilles": "ANT" },
  { "New Caledonia": "NCL" },
  { "New Zealand": "NZL" },
  { Nicaragua: "NIC" },
  { Niger: "NER" },
  { Nigeria: "NGA" },
  { Niue: "NIU" },
  { "Norfolk Island": "NFK" },
  { "North Korea": "PRK" },
  { "Northern Mariana Islands": "MNP" },
  { Norway: "NOR" },
  { Oman: "OMN" },
  { Pakistan: "PAK" },
  { Palau: "PLW" },
  { "Palestinian Territory, Occupied": "PSE" },
  { Panama: "PAN" },
  { "Papua New Guinea": "PNG" },
  { Paraguay: "PRY" },
  { Peru: "PER" },
  { Philippines: "PHL" },
  { Pitcairn: "PCN" },
  { Poland: "POL" },
  { Portugal: "PRT" },
  { "Puerto Rico": "PRI" },
  { Qatar: "QAT" },
  { Reunion: "REU" },
  { Romania: "ROU" },
  { Russian: "RUS" },
  { Rwanda: "RWA" },
  { "Saint Helena": "SHN" },
  { "Saint Kitts and Nevis": "KNA" },
  { "Saint Lucia": "LCA" },
  { "Saint Vincent and the Grenadines": "VCT" },
  { "Saint-Pierre and Miquelon": "SPM" },
  { Samoa: "WSM" },
  { "San Marino": "SMR" },
  { "Sao Tome and Principe": "STP" },
  { "Saudi Arabia": "SAU" },
  { Senegal: "SEN" },
  { Serbia: "SRB" },
  { Seychelles: "SYC" },
  { "Sierra Leone": "SLE" },
  { Singapore: "SGP" },
  { Slovakia: "SVK" },
  { Slovenia: "SVN" },
  { "Solomon Islands": "SLB" },
  { Somalia: "SOM" },
  { "South Africa": "ZAF" },
  { "South Georgia and the South Sandwich Islands": "SGS" },
  { "South Korea": "KOR" },
  { Spain: "ESP" },
  { "Sri Lanka": "LKA" },
  { Sudan: "SDN" },
  { Suriname: "SUR" },
  { "Svalbard and Jan Mayen": "SJM" },
  { Swaziland: "SWZ" },
  { Sweden: "SWE" },
  { Switzerland: "CHE" },
  { Syria: "SYR" },
  { Taiwan: "TWN" },
  { Tajikistan: "TJK" },
  { Tanzania: "TZA" },
  { Thailand: "THA" },
  { "Timor-Leste (East Timor)": "TLS" },
  { Togo: "TGO" },
  { Tokelau: "TKL" },
  { Tonga: "TON" },
  { "Trinidad and Tobago": "TTO" },
  { Tunisia: "TUN" },
  { Turkey: "TUR" },
  { Turkmenistan: "TKM" },
  { "Turks and Caicos Islands": "TCA" },
  { Tuvalu: "TUV" },
  { Uganda: "UGA" },
  { Ukraine: "UKR" },
  { "United Arab Emirates": "ARE" },
  { "United Kingdom": "GBR" },
  { "United States": "USA" },
  { "United States Minor Outlying Islands": "UMI" },
  { Uruguay: "URY" },
  { Uzbekistan: "UZB" },
  { Vanuatu: "VUT" },
  { Venezuela: "VEN" },
  { "Viet Nam": "VNM" },
  { "Virgin Islands,  British": "VGB" },
  { "Virgin Islands,  U.S.": "VIR" },
  { "Wallis and Futuna": "WLF" },
  { "Western Sahara": "ESH" },
  { Yemen: "YEM" },
  { Zambia: "ZMB" },
  { Zimbabwe: "ZWE" }
];
